// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__2QXOy","selected":"Chip_selected__35LBQ"};